// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMask from 'v-mask'
import VueNumeric from 'vue-numeric'
import VueSignaturePad from 'vue-signature-pad'
import VueTabs from 'vue-nav-tabs'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueMoment from 'vue-moment'
import swal from 'sweetalert'
import VueQuagga from 'vue-quaggajs'
import VueApexCharts from 'vue-apexcharts'
import store from '@/ambiente/store'
import RLogADMServicos from '@/components/Rest/RLogADMServicos'
import router from './router'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import RSessao from '@/components/Rest/RSessao'

import 'vue-nav-tabs/themes/vue-tabs.css'

Vue.config.productionTip = false;

axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'text/plain; charset=UTF-8';

axios.santriGET = function(url, parametros, segundos, multipla_tentativa) {
  const milissegundos = !segundos ? 0 : (segundos * 1000)

  return new Promise((resolve, reject) => {
    let sucesso = 0;
    let RedeOnline = true;

    try {
      RedeOnline = navigator.onLine;
    } catch (error) {
      RedeOnline = true;
    }

    if (!RedeOnline){
      throw new Error('SEM_CONEXAO');
    }

    try {
      let cn_dp_x_y = {velocidade: Biblioteca.buscarVelocidadeDownloadDispositivo()}
      parametros.cn_dp_x_y = cn_dp_x_y;
    } catch (error) {
      // Fazer nada
    }

    let request = {
      url: process.env.API + url,
      parametros: parametros
    }

    url = process.env.API + url;
    if (parametros != '') {
      url += '?' + JSON.stringify(parametros);
    }
    
    if (segundos > 0) {
      /* ------ Criando trava de timeout ------ */
      sucesso = setTimeout(
        () => {
          try {
            throw new Error('TIMEOUT');
          }
          catch(e) {
            /* ------ Ao exceder o tempo, enviando logs para o servidor ------ */
            try {
              axios.gravarLogsExecoesRequisicoes(request, e.response, 'TIMEOUT');
            } 
            finally {
              /* ------ Se não for múltipla tentativa, sobe a exceção para a tela ------ */
              if (!multipla_tentativa) {
                reject(e);
                return;
              }
              
              /* ------ Sendo múltipla tentativa, cria outro timeout para tentar novamente ------ */
              /* ------     E sair novamente se estourar novamente o prazo. Já tem log,    ------ */ 
              /* ------               Então não precisa gravar log novamente               ------ */
              sucesso = setTimeout(
                () => {
                  reject(e);
                  return;
                },
                milissegundos
              )

              /* ------ Com o timeout criado, tentar enviar novamente a requisição ------ */
              axios.get(url)
              .then((response) => {
                if (segundos > 0) {
                  clearTimeout(sucesso);
                } 

                return resolve(response);
              })
              .catch(e => {

                if (e.response.status == 403){
                  RSessao.setExigirCertificacaoUsuario('S');
                }

                /* ------ Caso a requisição seja respondida com erro ------ */
                clearTimeout(sucesso);

                try {
                  /* ------ Tenta enviar os logs sendo um erro desconhecido ------ */
                  if ((!e) || (!e.response) || (!e.response.data) || (!e.response.data.houve_erro)) {
                    axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO');
                  }
                }
                finally {         
                  /* ------ Trata o retorno e sobe a exceção para a tela requisitante ------ */         
                  let retorno = {};
                  retorno.houve_erro = 'S';
                  
                  if ((e) && (e.response) && (e.response.data) && (e.response.data.mensagem)) {
                    retorno.mensagem = e.response.data.mensagem;
                  } else {
                    retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
                  }

                  RSessao.verificarRestricaoLogin(retorno.mensagem);
                  
                  reject(retorno);
                }
              })
            }
          }
        },
        milissegundos
      )

      /* ------ Aqui é de fato a primeira requisição, que deverá operar ------ */ 
      /* ------        garantida pelo timeout acima implementado        ------ */
      axios.get(url)
      .then((response) => {
        if (segundos > 0) {
          clearTimeout(sucesso);
        }

        return resolve(response);
      })
      .catch(e => {

        if (e.response.status == 403){
          RSessao.setExigirCertificacaoUsuario('S');
        }

        if (segundos > 0) {
          clearTimeout(sucesso);
        }

        try {
          /* ------ No fracasso desconhecido, tenta gravar os logs da requisição ------ */
          if ((!e) || (!e.response) || (!e.response.data) || (!e.response.data.houve_erro)) {
            axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO');
          }
        }
        finally {
          let retorno = {};
          retorno.houve_erro = 'S';

          if ((e) && (e.response) && (e.response.data) && (e.response.data.mensagem)) {
            retorno.mensagem = e.response.data.mensagem;
          }
          else {              
            retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
          }

          RSessao.verificarRestricaoLogin(retorno.mensagem);
        
          reject(retorno);
        }
      })
    }
    else {
      /* ------ Quando a requisição não tem timeout ------ */
      axios.get(url)
      .then((response) => {
        return resolve(response);    
      })
      .catch(e => {

        if (e.response.status == 403){
          RSessao.setExigirCertificacaoUsuario('S');
        }

        try {
          /* ------ No fracasso desconhecido, tenta gravar os logs da requisição ------ */
          if ((!e) || (!e.response) || (!e.response.data) || (!e.response.data.houve_erro)) {
            axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO');
          }
        }
        finally {
          let retorno = {};
          retorno.houve_erro = 'S';

          if ((e) && (e.response) && (e.response.data) && (e.response.data.mensagem)) {
            retorno.mensagem = e.response.data.mensagem;
          }
          else {              
            retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
          }

          RSessao.verificarRestricaoLogin(retorno.mensagem);
        
          reject(retorno);
        }
      })
    }
  })
}

axios.santriPOST = function(url, parametros, segundos, multipla_tentativa) {
  const milissegundos = !segundos ? 0 : (segundos * 1000);

  return new Promise((resolve, reject) => {
    let sucesso = 0;
    let RedeOnline = true;

    try {
      RedeOnline = navigator.onLine;
    } catch (error) {
      RedeOnline = true;
    }

    if (!RedeOnline){
      throw new Error('SEM_CONEXAO');
    }

    try {
      let cn_dp_x_y = {velocidade: Biblioteca.buscarVelocidadeDownloadDispositivo()}
      parametros.cn_dp_x_y = cn_dp_x_y;
    } catch (error) {
      // Fazer nada
    }
    
    let request = {
      url: process.env.API + url,
      parametros: parametros
    }              
    
    if (segundos > 0) {
      sucesso = setTimeout(() => {
        try{
          throw new Error('TIMEOUT');
        } catch(e) {
          //Deu TIMEOUT
          try{
            //Gravar os Logs
            console.log('TIME OUT: ' + JSON.stringify(request));
            axios.gravarLogsExecoesRequisicoes(request, e.response, 'TIMEOUT');
          } finally{
            //Se não for tentar novamente, sai fora e sobe a exceção
            if (!multipla_tentativa){              
              reject(e);
              return;
            }else{
              sucesso = setTimeout(() => {
                try{
                  throw new Error('TIMEOUT');
                } catch(e){
                  //Deu TIMEOUT
                  try{
                    //Gravar os Logs
                    axios.gravarLogsExecoesRequisicoes(request, e.response, 'TIMEOUT 2 vezes');
                    console.log('time out de novo');
                  } finally{                    
                      reject(e);
                      return;
                  }
                }
              }, milissegundos)
              
              axios.post(process.env.API + url, JSON.stringify(parametros))
              .then((response) => {
                if (segundos > 0) {
                  clearTimeout(sucesso);
                }

                return resolve(response);
              })
              .catch(e => {
                clearTimeout(sucesso);

                if (e.response.status == 403){
                  RSessao.setExigirCertificacaoUsuario('S');
                }

                try{
                  if (!((e) && (e.response) && (e.response.data) && (e.response.data.houve_erro))) {
                    axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO');
                  }
                }finally{
                  let retorno = {};
                  retorno.houve_erro = 'S';

                  if ((e) && (e.response) && (!e.response.data) && (e.response.data.mensagem)) {
                    retorno.mensagem = e.response.data.mensagem;
                  } else {
                    retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
                  }

                  RSessao.verificarRestricaoLogin(retorno.mensagem);
                  
                  return reject(retorno);
                }
              })
            }
          }
        }
      }, milissegundos)
    }

    axios.post(process.env.API + url, JSON.stringify(parametros))
    .then((response) => {
      if (segundos > 0) {
        clearTimeout(sucesso);
      }
      
      return resolve(response);
    })
    .catch(e => {
      clearTimeout(sucesso);

      if (e.response.status == 403){
        RSessao.setExigirCertificacaoUsuario('S');
      }

      try{
        if (!((e) && (e.response) && (e.response.data) && (e.response.data.houve_erro))) {
          axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO');
        }
      }finally{
        if (multipla_tentativa){
          if (segundos > 0) {
            sucesso = setTimeout(() => {
              try{
                throw new Error('TIMEOUT');
              }catch(e){
                try{                  
                  axios.gravarLogsExecoesRequisicoes(request, e.response, 'TIMEOUT. 2 tentativas.')
                } finally{
                  let retorno = {};
                  retorno.houve_erro = 'S';

                  if ((e) && (e.response) && (!e.response.mensagem)) {
                    retorno.mensagem = e.response.mensagem;
                  } else {
                    retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
                  }          
                  
                  RSessao.verificarRestricaoLogin(retorno.mensagem);

                  return reject(retorno);
                }
              }
            }, 
              milissegundos
            )
          }
          
          axios.post(process.env.API + url, JSON.stringify(parametros))
          .then((response) => {
            if (segundos > 0) {
              clearTimeout(sucesso);
            }
            
            return resolve(response);
          })
          .catch(e => {
            clearTimeout(sucesso);

            if (e.response.status == 403){
              RSessao.setExigirCertificacaoUsuario('S');
            }

            try {
              if (!((e) && (e.response) && (e.response.data) && (e.response.data.houve_erro))) {
                axios.gravarLogsExecoesRequisicoes(request, e.response, 'DESCONHECIDO. 2 tentativas.');
              }
            } finally {
              let retorno = {};
              retorno.houve_erro = 'S'
              if ((e) && (e.response) && (e.response.data) && (e.response.data.mensagem)) {
                retorno.mensagem = e.response.data.mensagem
              }else{              
                retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.'
              } 

              RSessao.verificarRestricaoLogin(retorno.mensagem);

              return reject(retorno)  
            }  

          });

          return;
        }else{
          let retorno = {};
          retorno.houve_erro = 'S';

          if ((e) && (e.response) && (e.response.data) && (e.response.data.mensagem)) {
            retorno.mensagem = e.response.data.mensagem
          } else {
            retorno.mensagem = 'Ocorreu um erro desconhecido! Tente novamente.';
          }

          RSessao.verificarRestricaoLogin(retorno.mensagem);
        
          return reject(retorno);
        }
      }
    })    
  })
}

axios.gravarLogsExecoesRequisicoes = function(request, response, tipo){
  let RedeOnline = true;

  try {
    RedeOnline = navigator.onLine;
  } catch (error) {
    RedeOnline = true;
  }

  let status_conexao = RedeOnline ? 'online' : 'offline';
  /*RLogADMServicos.gravarEnviarLogs(
    Object.assign({}, request), 
    Object.assign({}, response), 
    tipo, 
    status_conexao, 
    navigator.connection.downlink
  );*/
}

Vue.use(VueAxios, axios)
Vue.use(VueSignaturePad)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMask)
Vue.use(VueTabs)
Vue.use(VueMoment)
Vue.use(VueQuagga)
Vue.use(VueApexCharts)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App, VueNumeric },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js